import React from "react";
import QuiqButton from "src/shared/QuiqButton";
import "./NoEntityResults.scss";
import { SearchIcon } from "./SearchIcon";

interface NoEntityResultsProps {
  searchTerm: string;
  createEntityCallback: () => void;
}

export const NoEntityResults: React.SFC<NoEntityResultsProps> = ({
  searchTerm,
  createEntityCallback
}) => (
  <div className="NoEntityResults">
    <SearchIcon />
    <div className="NoEntityResults--big-text">
      No search results found for "{searchTerm}"
    </div>
    <div className="NoEntityResults--small-text">
      Please check your spelling or create a new Entity.
    </div>
    <QuiqButton
      className="NoEntityResults--create-button"
      color="blue"
      onClick={createEntityCallback}
    >
      Create New
    </QuiqButton>
  </div>
);



// WEBPACK FOOTER //
// ./src/entityList/NoEntityResults.tsx